import type {
    AnatomySampleMap
} from "../types";
import {
    SwipeableRow,
    NativeSelect,
    TabBar,
    Item,
    Text
} from "ncore-ui-kit";
import {
    SearchIcon,
    UserIcon,
    HomeIcon,
    FileIcon,
    StarIcon
} from "../icons";
import {
    shapeConfigs
} from "../sampleTokens";

export const mobileSamples: AnatomySampleMap = {
    NativeSelect: (t) => ({
        node: <NativeSelect
            data={[
                {
                    title: t("sample.option1"),
                    value: "1"
                },
                {
                    title: t("sample.option2"),
                    value: "2"
                },
                {
                    title: t("sample.option3"),
                    value: "3"
                }
            ]}
            hintText={t("sample.hint")}
            title={t("sample.label")}
            spreadBehaviour="stretch"
            initialValue="1"
        />,
        width: shapeConfigs.drawerWidth,
        maxScale: 3
    }),
    SwipeableRow: (t) => ({
        node: <SwipeableRow
            trailingActions={[
                {
                    title: t("sample.action"),
                    icon: StarIcon,
                    key: "star"
                },
                {
                    title: t("sample.label"),
                    icon: FileIcon,
                    key: "file"
                }
            ]}
            description={t("sample.message")}
            title={t("sample.name")}
            interactionMode="swipe"
        >
            <Item
                onPress={() => undefined}
            >
                <Item.Media
                    icon={UserIcon}
                />
                <Item.Content>
                    <Item.Title>
                        {t("sample.name")}
                    </Item.Title>
                    <Item.Description>
                        {t("sample.message")}
                    </Item.Description>
                </Item.Content>
                <Item.Actions>
                    <Text
                        variant="bodySmallSize"
                        color="mid"
                    >
                        {t("sample.time")}
                    </Text>
                </Item.Actions>
            </Item>
        </SwipeableRow>,
        width: shapeConfigs.drawerWidth,
        maxScale: 3
    }),
    TabBar: (t) => ({
        node: <TabBar
            items={[
                {
                    title: t("sample.home"),
                    icon: HomeIcon,
                    key: "home"
                },
                {
                    title: t("sample.library"),
                    icon: FileIcon,
                    key: "library",
                    badge: 3
                },
                {
                    title: t("sample.search"),
                    icon: SearchIcon,
                    key: "search"
                },
                {
                    title: t("sample.item1"),
                    icon: UserIcon,
                    key: "profile"
                }
            ]}
            isHiddenOnKeyboard={false}
            activeKey="home"
        />,
        width: shapeConfigs.drawerWidth,
        maxScale: 2
    })
};
